import { cn } from '@/lib/cn';

export default function Skeleton({ className }: { className?: string }) {
  return <div className={cn('lb-shimmer rounded-md bg-background-200', className)} />;
}